import { escapeHtml, openPrintWindow, tableHtmlFromRows } from './exportUtils';
import { formatDateIN, formatDateTimeIN } from './dateFormat';

const formatBytes = (bytes) => {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n <= 0) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const openSubmittalTransmittalPrint = (data) => {
  if (!data) return;

  const attachmentRows = (data.attachments || []).map((att, idx) => [
    String(idx + 1),
    att.original_name || att.file_name || '—',
    att.mime_type || '—',
    formatBytes(att.size_bytes),
    att.uploaded_by?.name || '—',
  ]);

  const bodyHtml = `
    <div class="meta" style="margin-bottom: 20px;">
      <p><strong>Transmittal No:</strong> ${escapeHtml(data.transmittal_no || '—')}</p>
      <p><strong>Submittal No:</strong> ${escapeHtml(data.submittal_no || '—')} &nbsp;|&nbsp; <strong>Revision:</strong> ${escapeHtml(data.revision || '—')}</p>
      <p><strong>Project:</strong> ${escapeHtml(data.project_name || '—')}${data.project_code ? ` (${escapeHtml(data.project_code)})` : ''}</p>
      <p><strong>Category:</strong> ${escapeHtml(data.category?.name || '—')}</p>
      <p><strong>Subject:</strong> ${escapeHtml(data.subject || '—')}</p>
      <p><strong>Purpose:</strong> ${escapeHtml(data.purpose || '—')} &nbsp;|&nbsp; <strong>Status:</strong> ${escapeHtml(String(data.current_status || '—').replace(/_/g, ' '))}</p>
      <p><strong>Submitted By:</strong> ${escapeHtml(data.submitted_by?.name || '—')} &nbsp;|&nbsp; <strong>Date:</strong> ${escapeHtml(formatDateTimeIN(data.submitted_at))}</p>
      <p><strong>Submitted To:</strong> ${escapeHtml(data.submitted_to_party?.name || '—')}${data.submitted_to_user?.name ? ` (${escapeHtml(data.submitted_to_user.name)})` : ''}</p>
      <p><strong>Due Date:</strong> ${escapeHtml(formatDateIN(data.due_date))}</p>
      ${data.remarks ? `<p><strong>Remarks:</strong> ${escapeHtml(data.remarks)}</p>` : ''}
    </div>

    <h3>Attachments</h3>
    ${tableHtmlFromRows({
      headers: ['#', 'File Name', 'Type', 'Size', 'Uploaded By'],
      rows: attachmentRows,
      emptyMessage: 'No attachments listed',
    })}

    <div style="margin-top: 48px; display: grid; grid-template-columns: 1fr 1fr; gap: 48px;">
      <div>
        <p style="border-top: 1px solid #333; padding-top: 8px; margin-top: 64px;"><strong>Submitted By</strong></p>
        <p style="margin: 4px 0 0; color: #6b7280;">Name &amp; Signature</p>
        <p style="margin: 8px 0 0;">${escapeHtml(data.submitted_by?.name || '')}</p>
      </div>
      <div>
        <p style="border-top: 1px solid #333; padding-top: 8px; margin-top: 64px;"><strong>Received By</strong></p>
        <p style="margin: 4px 0 0; color: #6b7280;">Name &amp; Signature</p>
        <p style="margin: 8px 0 0;">${escapeHtml(data.submitted_to_user?.name || data.submitted_to_party?.name || '')}</p>
      </div>
    </div>
  `;

  openPrintWindow({
    title: 'Submittal Transmittal',
    subtitle: data.transmittal_no ? `Transmittal ${data.transmittal_no}` : '',
    bodyHtml,
    extraStyles: `
      .meta p { margin: 4px 0; font-size: 13px; }
      h3 { font-size: 15px; margin: 24px 0 8px; }
    `,
  });
};
